import React, { useEffect, useRef, useState, useTransition } from "react";
import { useTranslation } from "react-i18next";
import { ColoredButton } from "styledComponents/buttons";
import { useDebouncedCallback } from "use-debounce";



import { CommonFlex, CommonText, Container, PageTitle } from "../../styledComponents/common";
import ChangePasswordComponent from "../ChangePassword/ChangePassword";
import ProfilePicture from "./ProfilePicture";
import UserDeleteProfile from "./UserDeleteProfile";
import UserOrg from "./UserOrganization";
import UserProfileEdit from "./UserProfileEdit";
import { DangerContainer } from "./profileStyles";


const UserProfile = props => {
  const { t } = useTranslation();
  const firstLoad = useRef(true);
  // const [isProfilePicRemoveModalOpen, setIsProfilePicRemoveModal] =
  //   useState(false);
  // const toggleProfilePicRemoveModal = () => {
  //   setIsProfilePicRemoveModal(!isProfilePicRemoveModalOpen);
  // };
  const handleUserProfileRemove = useDebouncedCallback(() => {
    const payload = {};
    payload.image = null;
    payload.thumbnail = null;
    props.profileOperation(payload);
    // setIsProfilePicRemoveModal(false);
  }, 500);

  useEffect(() => {
    const { profileOperation, auth, getUserEmails, getAccountDeleteStatus } =
      props;

    if (auth.auth.is_profile_created === "True") {
      let payload = {
        method: "GET",
      };
      profileOperation(payload);
    }
    getUserEmails();
    getAccountDeleteStatus();
  }, []);

  useEffect(() => {
    if (firstLoad.current) {
      firstLoad.current = false;
      return;
    }

    if (props.profile?.accountDeleteStatus?.has_delete_request) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [props.profile?.accountDeleteStatus?.has_delete_request]);

  return (
    <>
      <div className="content">
        <PageTitle>{t("my_profile")}</PageTitle>
        {props.profile?.accountDeleteStatus?.has_delete_request && (
          <DangerContainer padding="20px" marginTop="20px">
            <CommonFlex direction="column" alignItems="flex-start" gap="10px">
              <CommonText title>Account deletion scheduled</CommonText>
              <CommonText>
                Account will be deleted at:{" "}
                {new Date(
                  props.profile.accountDeleteStatus.scheduled_deletion_at,
                ).toLocaleString()}
              </CommonText>
              <CommonText>
                Please back up any data you want to keep before the scheduled
                deletion time.
              </CommonText>
              <CommonText>
                If you have changed your mind, you can cancel the deletion
                request below.
              </CommonText>
              <ColoredButton
                type="delete"
                disabled={props.profile.cancelDeletionLoading}
                onClick={() => {
                  if (props.profile.cancelDeletionLoading) return;
                  props.cancelAccountDeletion();
                }}
              >
                {props.profile.cancelDeletionLoading
                  ? "Cancelling..."
                  : "Cancel account deletion"}
              </ColoredButton>
            </CommonFlex>
          </DangerContainer>
        )}
        <Container
          padding="30px"
          marginTop="20px"
          style={{ position: "relative" }}
        >
          <ProfilePicture
            {...props.profile.profileData}
            history={props.history}
            redirect={props.redirect}
            handleSave={props.profileOperation}
            // toggleProfilePicRemoveModal={toggleProfilePicRemoveModal}
            handleUserProfileRemove={handleUserProfileRemove}
            // isProfilePicRemoveModalOpen={isProfilePicRemoveModalOpen}
            updateIsLoading={props.updateIsLoading}
          />
          <UserProfileEdit
            history={props.history}
            redirect={props.redirect}
            organizations={
              props.organizations && props.organizations.data
                ? props.organizations.data.map(o => o.name)
                : []
            }
            profileDataError={props.profileDataError}
            emails={props.profile.userEmails}
            getUserEmails={props.getUserEmails}
            requestUserEmails={props.profile.requestUserEmails}
            addEmail={props.addEmail}
            deleteEmail={props.deleteEmail}
            makeEmailDefault={props.makeEmailDefault}
            {...props.profile.profileData}
            handleSave={props.profileOperation}
            loginProfileCreatedReset={props.loginProfileCreatedReset}
            updateIsLoading={props.updateIsLoading}
          />
        </Container>
        <Container padding="30px" marginTop="20px">
          <ChangePasswordComponent
            changePasswordAction={props.changePasswordAction}
            passwordChanged={props.passwordChanged}
            loginProfileCreatedReset={props.loginProfileCreatedReset}
            history={props.history}
            redirect={props.redirect}
          />
        </Container>
        <Container padding="30px" marginTop="20px">
          <UserOrg
            organizations={props.organizations ? props.organizations.list : []}
          />
        </Container>
        {!props.profile?.accountDeleteStatus?.has_delete_request ? (
          <DangerContainer padding="30px" marginTop="20px">
            <UserDeleteProfile profileDelete={props.profileDelete} />
          </DangerContainer>
        ) : null}
      </div>
    </>
  );
};
export default UserProfile;